import React, { useState } from 'react';
import { Button } from './ui/button';
import { Heart, Sparkles } from 'lucide-react';

const EnoughButton = ({ onClick }) => {
  const [isClicked, setIsClicked] = useState(false);
  
  const handleClick = () => {
    setIsClicked(true);
    onClick?.();
    
    setTimeout(() => setIsClicked(false), 2000);
  };
  
  return (
    <div className="text-center py-8 relative">
      {/* Decorative elements */}
      <div className="absolute top-4 left-1/4 text-xl opacity-20">🌿</div>
      <div className="absolute top-4 right-1/4 text-xl opacity-20">🍃</div>
      
      <Button
        data-testid="enough-button"
        onClick={handleClick}
        disabled={isClicked}
        className={`
          vintage-btn px-8 py-8 rounded-lg text-lg font-serif
          transition-all duration-500 transform
          ${isClicked 
            ? 'bg-good-bg text-good-text scale-105 shadow-lifted-lg border-2 border-good-border' 
            : 'btn-sage shadow-lifted'
          }
        `}
      >
        {isClicked ? (
          <span className="flex items-center gap-2 animate-fade-in">
            <Sparkles className="w-5 h-5" />
            You did enough today
            <Sparkles className="w-5 h-5" />
          </span>
        ) : (
          <span className="flex items-center gap-2">
            <Heart className="w-5 h-5" />
            This is enough for today
          </span>
        )}
      </Button>
      
      {isClicked && (
        <p className="mt-4 text-ink-500 animate-fade-in-up text-sm font-handwritten text-xl">
          Take a breath. You've carried so much today. 🌿
        </p>
      )}
    </div>
  );
};

export default EnoughButton;
